import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, Card } from 'antd-mobile-v5'
import SignatureCanvas from 'react-signature-canvas'
import { dataURLtoBlobOrBlodURL, showModal } from '../common/utils'
import { CheckCircleFill, ExclamationCircleFill } from 'antd-mobile-icons'
import { useGetOssFullUrl, useUploadFileToOss } from '../../services/hooks'

import styles from '../common/Signature.module.css'

const Signature = ({ initSignature, modified, filePath, title, signature, onSuccess, oss, onClear }) => {
  const dispatch = useDispatch()
  const intl = useIntl()
  const [signCtrl, setSignCtrl] = useState()
  const [showCanvas, setShowCanvas] = useState(true)
  const [signatureUrl, setSignatureUrl] = useState('')
  const { runAsync: uploadToOss } = useUploadFileToOss()
  const { runAsync: getOssUrl } = useGetOssFullUrl()

  useEffect(() => {
    if (initSignature) setSignatureUrl(initSignature)
  }, [initSignature])

  useEffect(() => {
    if (signatureUrl) setShowCanvas(false)
  }, [signatureUrl])

  const getUploadData = (file) => {
    const filename = `${oss.dir}${filePath}/${new Date().getTime()}`
    const formData = new FormData()
    formData.append('key', filename)
    formData.append('OSSAccessKeyId', oss.accessid)
    formData.append('policy', oss.policy)
    formData.append('Signature', oss.signature)
    formData.append('file', dataURLtoBlobOrBlodURL(file))
    formData.append('success_action_status', 200)
    return formData
  }

  const uploadSignature = (imgSrc) => {
    if (!signCtrl.isEmpty()) {
      const formData = getUploadData(imgSrc)
      // dispatch(submitSignature({formData}))
      uploadToOss(oss.host, formData).then((res) => {
        getOssUrl(res.url).then((url) => {
          onSuccess(res.url)
          setSignatureUrl(url)
        })
      })
    } else {
      showModal(
        intl.formatMessage({ id: 'common-errorTitle' }),
        intl.formatMessage({ id: 'dm-form-signature-confirm' }),
        () => {},
        () => {},
        intl.formatMessage({ id: 'common-comfirmBtn' }),
        intl.formatMessage({ id: 'common-cancel' })
      )
    }
  }

  const clearSignatureImg = () => {
    setSignatureUrl('')
    onClear()
    if (signatureUrl) {
      setShowCanvas(true)
      return
    }
    signCtrl.clear()
  }

  return (
    <Card
      style={{ overflow: 'hidden' }}
      title={title ? title : <FormattedMessage id="dm-form-signature" />}
      extra={
        signatureUrl ? (
          <CheckCircleFill fontSize={24} color="rgb(98,188,126)" />
        ) : (
          <ExclamationCircleFill fontSize={24} color="rgb(239,181,87)" />
        )
      }
    >
      {!showCanvas && signatureUrl ? (
        <div className={styles.signatureImgBox}>
          <img className={styles.signatureImg} src={signatureUrl} alt="signature" />
        </div>
      ) : (
        <SignatureCanvas
          canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
          ref={(ref) => {
            setSignCtrl(ref)
          }}
        />
      )}
      {modified && (
        <div className={styles.signatureBtns}>
          <Button
            color="primary"
            fill="outline"
            size="small"
            className={styles['confirm-btn']}
            onClick={() => clearSignatureImg()}
          >
            <FormattedMessage id="dm-form-signature-clear" />
          </Button>
          <Button
            color="primary"
            fill="solid"
            size="small"
            className={styles['confirm-btn']}
            onClick={() => uploadSignature(signCtrl.toDataURL('image/png'))}
          >
            <FormattedMessage id="dm-form-signature-save" />
          </Button>
        </div>
      )}
    </Card>
  )
}

export default Signature
